const position_admin = "Administrator"
const position_creative = "Creative director"

export {
    position_admin,
    position_creative,
}

